Lesson (stxt.play.tutorial): Next steps
	Progress: 6 (extra)
	Explanation >>
		From this point, you can try the rest
		of the examples, and see how templates
		work. Play with them, adding and
		removing elements, and see how that
		affects the existing documents:

		- If appropriate, use MARKDOWN instead of TEXT
		- Try other types, such as INTEGER or ENUM
		- Make documents with multiple namespaces
		- Use different cardinalities for the children

		Once you are confident, you can
		browse https://stxt.dev to see
		the specification of the language,
		tools, parsers, and more.
